module.exports = __webpack_public_path__ + "static/media/gray-circle.dcb705da.png";